export const TPR_PLAYBOOK_NAME = 'Refine Test Procedures'
